/**
 * Escapes `<` as `\u003c` so a `</script>` or `<!--` in a CMS text field cannot close the tag;
 * JSON.parse reads it back unchanged. Print the result in a plain <script>, not next/script,
 * which defers into `self.__next_s` and is missing from the SSR HTML crawlers read.
 */
export function toJsonLd(value: unknown): string {
  return JSON.stringify(value).replace(/</g, '\\u003c');
}
